import axios from "axios";
import config from "../../../config";
import {
  ClaimTypesDataModel,
  ClientDataModel,
  ClientTypesDataModel,
  ClientModel,
} from "./types";

const apiUrl = config.api;

export const getClientInfo = async (): Promise<ClientDataModel> => {
  const response = await axios.get<ClientDataModel>(`${apiUrl}/clients`);

  return response.data;
};

export const getClientTypes = async (): Promise<ClientTypesDataModel> => {
  const response = await axios.get<ClientTypesDataModel>(
    `${apiUrl}/client/types`,
  );

  return response.data;
};

export const getClaimTypes = async (): Promise<ClaimTypesDataModel> => {
  const response = await axios.get<ClaimTypesDataModel>(`${apiUrl}/claim/type`);

  return response.data;
};

export const createClient = async (body: ClientModel): Promise<ClientModel> => {
  const response = await axios.put<ClientModel>(`${apiUrl}/client`, body);

  return response.data;
};

export const updateClient = async (body: ClientModel): Promise<ClientModel> => {
  const response = await axios.put<ClientModel>(
    `${apiUrl}/client/${body.clientInformation.id}`,
    body,
  );

  return response.data;
};

export const deleteClient = async (id: number): Promise<ClientModel> => {
  const response = await axios.delete<ClientModel>(
    `${apiUrl}/clients/${id}/data`,
  );

  return response.data;
};

export const updateMappingComplete = async (
  clientId: number,
  mappingComplete: boolean,
): Promise<void> => {
  await axios.put(`${apiUrl}/clients/${clientId}/mapping-complete`, {
    mappingComplete,
  });
};

export default getClientInfo;
